import React, { useState } from "react";
import { Col, ConfigProvider, Form, Row } from "antd";
import Inputs from "../../../../biblio/Inputs/Inputs";
import Selects from "../../../../biblio/Selects/Selects";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { convertFileToBase64 } from "../../../../components/utils/utils";
import { UploadOutlined } from "@ant-design/icons";
import ar_EG from "antd/lib/locale/ar_EG";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/ar";
import HijriFeature from "../../../../biblio/HijriFeature";

dayjs.extend(updateLocale);

dayjs.updateLocale("ar", {
  weekStart: 6,
  weekdays: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
  weekdaysShort: ["أحد", "اثن", "ثلا", "أرب", "خمي", "جمع", "سبت"],
});

interface MotherProps {
  nationality: any;
  maritalStatus: any;
  healthStates: any;
  academicLevels: any;
  identificationTypes: any;
  form: any;
}

const MotherForm = ({
  nationality,
  maritalStatus,
  healthStates,
  academicLevels,
  identificationTypes,
  form,
}: MotherProps) => {
  const [isDeceased, setIsDeceased] = useState(false);

  const handleMaritalStatusChange = (value: any) => {
    const statusArray = maritalStatus.data || maritalStatus;

    const selectedStatus = statusArray.find(
      (status: any) => status.id === value.value
    );

    if (selectedStatus) {
      setIsDeceased(selectedStatus.deceased);
    }
  };

  /* Handle date change */
  const handleDateChange = (field: string) => (dateValue: any) => {
    form.setFieldsValue({
      [field]: dateValue,
    });
  };

  // Handle file change and convert to Base64
  const handleFileChange = async (fileList: any[]) => {
    const file = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = await convertFileToBase64(file);
        const imageData = {
          filename: file.name,
          data: base64,
        };

        form.setFieldsValue({
          mother_identify_image_ids: [imageData],
        });
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };

  /** find nationality by id */
  const findNationality =
    nationality &&
    nationality?.data?.find(
      (item: any) => item.id === form.getFieldValue(`mother_country_id`)?.value
    );

  return (
    <>
      <ConfigProvider locale={ar_EG} direction="rtl">
        <div className="takaful--title-tabs-sub">
          <span>معلومات عن الأم</span>
        </div>
        <Row gutter={16}>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_firstname"
              label="الاسم الأول"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_father_name"
              label="إسم الأب"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_grandfather_name"
              label="إسم الجد"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_family_name"
              label="إسم العائلة"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_eng_name"
              label="الاسم بالانجليزية"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_country_id"
              label="الجنسية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects options={nationality.data} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_birthday"
              label="تاريخ الميلاد"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <HijriFeature
                onChange={handleDateChange("mother_birthday")}
                maxDateGregorian={dayjs(new Date())}
                maxDateHijri={dayjs(new Date()).toDate()}
              />
            </Form.Item>
          </Col>

          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_identification_type_id"
              label="نوع الهوية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects options={identificationTypes.data} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_identification_number"
              label="رقم الهوية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
                {
                  len: 10,
                  message: "يجب أن يتكون رقم الهوية من 10 ارقام",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="tel" maxLength={10} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_identification_source"
              label="مصدر الهوية"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_identification_date"
              label="تاريخ الهوية"
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <HijriFeature
                onChange={handleDateChange("mother_identification_date")}
                maxDateGregorian={dayjs(new Date())}
                maxDateHijri={dayjs(new Date()).toDate()}
              />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_identification_deadline"
              label="تاريخ نهاية الهوية"
              rules={[
                {
                  // eslint-disable-next-line eqeqeq
                  required: findNationality?.code != "SA",
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
              validateTrigger="onBlur"
            >
              <HijriFeature
                onChange={handleDateChange("mother_identification_deadline")}
              />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="marital_status_id"
              label="الحالة الإجتماعية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects
                options={maritalStatus.data}
                onChange={handleMaritalStatusChange}
              />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="academic_level_id"
              label="المستوى الدراسي"
              rules={[
                {
                  required: !isDeceased,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects options={academicLevels.data} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="health_state_id"
              label="الحالة الصحية"
              rules={[
                {
                  required: !isDeceased,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects options={healthStates.data} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_email"
              label="البريد الإلكتروني"
              labelCol={{ className: "takaful--label-style" }}
              rules={[
                {
                  type: "email",
                  message:
                    "يجب  التأكد من أن البريد الإلكتروني مكتوب بشكل صحيح",
                },
              ]}
            >
              <Inputs placeholder="email@example.com" type="email" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_phone"
              label="الهاتف"
              rules={[
                {
                  required: !isDeceased,
                  message: "الرجاء تعبئة الحقل",
                },
                {
                  len: 10,
                  message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs placeholder="05XXXXXXXX" type="tel" maxLength={10} />
            </Form.Item>
          </Col>

          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="mother_identify_image_ids"
              label="صورة هوية/إقامة الأم"
              rules={[
                {
                  required: !isDeceased,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <UploadInput
                accept="image/*"
                text="صورة هوية/إقامة الأم"
                icon={<UploadOutlined />}
                multiple={false}
                maxCount={1}
                onChange={handleFileChange}
              />
            </Form.Item>
          </Col>
        </Row>
      </ConfigProvider>
    </>
  );
};

export default MotherForm;
